import { Component, OnInit, Input, Output, EventEmitter, HostListener, Renderer2, ElementRef } from '@angular/core';
import { WindowService } from '../window.service';

@Component({
  selector: 'app-window',
  templateUrl: './window.component.html',
  styleUrls: ['./window.component.css']
})
export class WindowComponent implements OnInit {
  @Input() title: string;
  @Input() component: string;
  @Output() close = new EventEmitter<void>();

  private isDragging = false;
  private draggedApp: string;
  private offsetX = 0;
  private offsetY = 0;

  constructor(private windowService: WindowService) { }

  ngOnInit(): void {
  }

  // Method to close the window
  closeWindow() {
    this.close.emit();
  }

  onMouseDown(event: MouseEvent) {
    const clickedWindow = document.getElementById(this.component);
    this.isDragging = true;
    this.draggedApp = this.component;
    this.offsetX = event.clientX - clickedWindow.getBoundingClientRect().left;
    this.offsetY = event.clientY - clickedWindow.getBoundingClientRect().top;
    const element = event.target as HTMLElement;
    element.classList.add('grabbing');
    document.body.style.userSelect = 'none';
    this.moveToTop();
  }

  onTouchStart(event: TouchEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('btn-close')) {
      return;
    }

    const clickedWindow = document.getElementById(this.component);
    this.isDragging = true;
    this.draggedApp = this.component;

    // Get the initial touch position
    const touch = event.touches[0];
    this.offsetX = touch.clientX - clickedWindow.getBoundingClientRect().left;
    this.offsetY = touch.clientY - clickedWindow.getBoundingClientRect().top;
    const element = event.target as HTMLElement;
    element.classList.add('grabbing');
    document.body.style.userSelect = 'none';

    // Prevent screen from dragging
    event.preventDefault();
    this.moveToTop();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      const window = document.getElementById(this.draggedApp);
      const left = event.clientX - this.offsetX;
      const top = event.clientY - this.offsetY;
      window.style.left = `${left}px`;
      window.style.top = `${top}px`;
    }
  }

  @HostListener('document:touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    if (this.isDragging) {
      const window = document.getElementById(this.draggedApp);
      const touch = event.touches[0];
      const left = touch.clientX - this.offsetX;
      const top = touch.clientY - this.offsetY;

      window.style.left = `${left}px`;
      window.style.top = `${top}px`;
      event.preventDefault();
    }
  }

  @HostListener('document:touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    this.isDragging = false;
    const element = event.target as HTMLElement;
    element.classList.remove('grabbing');
    document.body.style.userSelect = 'auto';
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.isDragging = false;
    const element = event.target as HTMLElement;
    element.classList.remove('grabbing');
    document.body.style.userSelect = 'auto';
  }

  moveToTop() {
    this.windowService.incrementHighestZIndex();
    const clickedWindow = document.getElementById(this.component);
    clickedWindow.style.zIndex = `${this.windowService.getHighestZIndex()}`;
  }

}
